export interface State {
    // your state content here
}

export const initialState: State = {};
